import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/settings/")({
  loader: ({ location }) => {
    if (location.pathname === "/settings") {
      throw redirect({
        to: "/settings/general",
      })
    }
    return null
  },
})
